window.jQuery = window.$ = jQuery
$(document).ready(function(){

  jQuery(function($){

    // Touch Device Detection
    var isTouchDevice = 'ontouchstart' in document.documentElement;
    if( isTouchDevice ) {
      $('body').removeClass('no-touch');
    }
  
  });



    $('.nav--toggle').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        $('.nav').addClass('nav-activated');
        $('.nav').toggleClass('active').removeClass('nav-activated');
        $('body').toggleClass('nav-open');
    });
    
    $("a[href^=http]").each(function(){
        if(this.href.indexOf(location.hostname) == -1) {
          $(this).attr({
              target: "_blank",
              rel: "nofollow",
              title: "Opens in a new window"
          });
        }
     });

     


$('.announcement--close').click(function () { //on click event
    days = 14; //number of days to keep the cookie
    myDate = new Date();
    myDate.setTime(myDate.getTime()+(days*24*60*60*1000));
    document.cookie = "close_announcement = comply_yes; path=/; expires = " + myDate.toGMTString(); //creates the cookie: name|value|expiry
    $(".announcement").hide(); //jquery to slide it up
    $(".container").removeClass('has-announcement'); //jquery to slide it up
  });

  var cookiename = getCookie("close_announcement");
  if (cookiename == "comply_yes") {
    $(".announcement").hide(); //jquery to slide it up
    $(".container").removeClass('has-announcement'); //jquery to slide it up
  }

  //function getCookie        
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1);
      if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
  }
  return "";
}

function checkCookie() {
  var username = getCookie("close_announcement");
  if (username != "") {
   alert("Welcome again " + username);
  } else {
    username = prompt("Please enter your name:", "");
    if (username != "" && username != null) {
      setCookie("username", username, 365);
    }
  }
}


  if($('body').hasClass('no-touch')) {


    // $('.nav--locations-item').hover( function(e) { //on click event
    //   $(this).addClass('is-open');
    //   $(this).attr('aria-expanded', true)
    //   $('body').addClass('nav-open');
    // }, function() {
    //   $(this).removeClass('is-open');
    //   $(this).attr('aria-expanded', false)
    //   $('body').removeClass('nav-open');
        
    // });

  } else {

    $('.nav--locations--anchor').click( function(e) { //on click event
      e.preventDefault();
    });




  }


  $('.nav-location--back').on('click', function(e) {
    $('.nav--locations-item').removeClass('is-open');
    $('.nav--locations-item').attr('aria-expanded', false);
  });

$('.nav--locations--anchor').click( function(e) { //on click event
  e.preventDefault();
  $('.nav--locations-item').removeClass('is-open');
  if($(this).parent().hasClass('is-open')) {
    $(this).parent().removeClass('is-open');
    $(this).parent().attr('aria-expanded', false)
    $('body').removeClass('nav-open');
  } else {
    
    $('.nav--locations-item').removeClass('is-open');
    $(this).parent().addClass('is-open');
    $(this).parent().attr('aria-expanded', true)
    $('body').addClass('nav-open');
  }
});

$(document).mouseup(function(e) 
{
    var container = $(".nav--locations--submenu");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
      $('.nav--locations-item').removeClass('is-open');
      $('.nav--locations-item').attr('aria-expanded', false)
      $('body').removeClass('nav-open');
    }
});
  
$(window).on('load resize', function(){

  });
});


/* jQuery function to set size of pdf object */

// $(function(){
// 	setTimeout(function(){
// 		$(document).ready(pdfSize);
// 		$(window).resize(pdfResize);	
// 	},800);
// 	function pdfSize() {		
// 		var height = $(window).height() - $("#toolbar").outerHeight() - 20
// 		$(".pdf object").css('height',height);
// 	}
// 	function pdfResize() {		
// 		var height = $(window).height() - $("#toolbar").outerHeight()
// 		$(".pdf object").css('height',height);		
// 	}
//   });